"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedVideoSwitchPartialForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const VideoPlayer_1 = __importDefault(require("../../../_components/VideoPlayer/VideoPlayer"));
const backoffice_1 = require("../../../../dsl/backoffice");
const version_abstract_form_1 = require("../version.abstract.form");
let EmbedVideoSwitchPartialForm = class EmbedVideoSwitchPartialForm extends version_abstract_form_1.EmbedVersionAbstractForm {
    constructor() {
        super(...arguments);
        /**
         * Regular expression to identify file type
         *
         * @private
         */
        this.regex = /\.(mov|avi|wmv|flv|3gp|mp4|mpg|ogg)$/;
        this.regexYoutube = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch?))\??v?=?([^#&?"]*).*/;
        this.icons = backoffice_1.DashmixIconName;
    }
    /**
     * Determines whether selected file matches with constrained regex
     */
    get isVideo() {
        if (!this.file || !this.file.url) {
            return false;
        }
        return this.file.url.match(this.regex) !== null;
    }
    /**
     * Checks whether content contains related file
     */
    get hasImage() {
        return !!this._content.thumbnail && typeof this._content.thumbnail.value !== 'undefined';
    }
    /**
     * Checks if file has some key/value
     */
    get hasFile() {
        return Object.prototype.hasOwnProperty.call(this.file, 'fileDescription') ||
            Object.prototype.hasOwnProperty.call(this.file, 'type');
    }
    /**
     * Checks whether pdf related is present in `content`
     */
    get hasVideo() {
        return !!this._content.video && typeof this._content.video.value !== 'undefined';
    }
    get videoObject() {
        return {
            file: this.file,
            url: this.url,
            onNetworkUrl: this._content.videoIdOnHash
        };
    }
    get url() {
        if (!this._content || !this._content.videoIdYoutube) {
            return '';
        }
        else {
            return `https://www.youtube.com/watch?v=${this._content.videoIdYoutube}`;
        }
    }
    set url(url) {
        if (!url) {
            return;
        }
        const youtubeMatch = url.match(this.regexYoutube);
        if (youtubeMatch) {
            this.onVideoIdYoutubeChange(youtubeMatch[7]);
        }
    }
    updateOnNetworkUrl(newLink) {
        if (newLink.includes('<script')) {
            const match = newLink.match(/src="([^"]+)"/);
            if (match) {
                newLink = match[1];
            }
        }
        this.onVideoIdOnHashChange(newLink);
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false,
        default: ''
    }),
    __metadata("design:type", String)
], EmbedVideoSwitchPartialForm.prototype, "imgTitle", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], EmbedVideoSwitchPartialForm.prototype, "onSelection", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], EmbedVideoSwitchPartialForm.prototype, "onVideoIdYoutubeChange", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], EmbedVideoSwitchPartialForm.prototype, "onVideoIdOnHashChange", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], EmbedVideoSwitchPartialForm.prototype, "onThumbnailRemove", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], EmbedVideoSwitchPartialForm.prototype, "onAutoplayToggle", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], EmbedVideoSwitchPartialForm.prototype, "onThumbnailSelection", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], EmbedVideoSwitchPartialForm.prototype, "onRemove", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true,
        default: {}
    }),
    __metadata("design:type", Object)
], EmbedVideoSwitchPartialForm.prototype, "file", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: false,
        default: null
    }),
    __metadata("design:type", Object)
], EmbedVideoSwitchPartialForm.prototype, "thumbnail", void 0);
EmbedVideoSwitchPartialForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedVideoSwitchPartialForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixFile: backoffice_1.DashmixFile,
            VideoPlayer: VideoPlayer_1.default
        },
        template: `
    <div class="row">

    <div class="form-group col-12 col-md-4">
      <div class="form-group" style="min-height: 290px">
        <p v-if="!isVideo && hasVideo" class="font-weight-bold text-danger">
          {{ $t('forms.embed.videoFileError') }} </p>
        <p v-else ><b>{{ $t('forms.embed.videoTitle') }}</b></p>

        <DashmixButton v-if="!hasVideo" variant="alt" :label="$t('forms.shared.search')" :icon="icons.SearchSolid"
                       @click="onSelection"/>

        <div v-if="hasVideo" class="p-3 bg-light d-flex flex-row justify-content-between align-items-center">
          <figure class="figure-with-btn__image-container">
            <DashmixButton class="figure-with-btn__delete-btn" variant="icon" theme="danger" :icon="icons.TrashSolid"
                           @click="onRemove"/>
            <DashmixFile class="figure-with-btn__image" :file="file"/>
            <figcaption>{{ file.fileDescription }}</figcaption>
          </figure>
        </div>
      </div>
      <VideoPlayer v-if="videoObject.file" :forceType="'hls'" :video="videoObject" :noThumbnail="true"
                   videoAttrId="video-cover-hls"
                   :baseVideoMetadata="{}" origin="hls" :ads="false"
                   :class="'video-preview'"
                   :videoClass="'hls'"/>
    </div>
    <div class="form-group col-12 col-md-4">
      <div class="form-group" style="min-height: 290px">
        <label for="iframe">{{ $t('forms.embed.iframe.label.youtube') }}</label>
        <DashmixTextArea size="small" :model.sync="url" :placeholder="$t('forms.embed.iframe.placeholder.youtube')"
                         name="iframe"/>
        <small>{{ $t('forms.embed.helpers') }}</small>

        <label for="videoId" class="mt-3">{{ $t('forms.embed.videoId') }}</label>
        <DashmixInput :model="_content.videoIdYoutube" name="videoId" disabled/>

      </div>
      <VideoPlayer v-if="videoObject.url" :forceType="'youtube'" :video="videoObject" :noThumbnail="true" videoAttrId="video-cover-youtube"
                   :baseVideoMetadata="{}" origin="youtube" :ads="false"
                   :class="'video-preview'"
                   :videoClass="'youtube'"/>
    </div>
    <div class="form-group col-12 col-md-4">
      <div class="form-group" style="min-height: 290px">
        <div class="font-weight-bold mb-2">OnNetwork:</div>
        <DashmixTextArea size="small" :model="_content.videoIdOnHash" @update:model="updateOnNetworkUrl"
                         :placeholder="$t('content.addons.cover.onNetworkUrl')"
                         name="addons_cover-video-onNetworkUrl"
        />
      </div>
      <VideoPlayer v-if="videoObject.onNetworkUrl" :forceType="'on'" :video="videoObject" :noThumbnail="true" videoAttrId="video-cover-on"
                   :baseVideoMetadata="{}" origin="on" :ads="false"
                   :class="'video-preview'"
                   :videoClass="'onNetwork'"/>
    </div>
    <div class="form-group col-12 col-md-6">
      <p><b>{{ $t('forms.embed.thumbnail') }}</b></p>

      <DashmixButton v-if="!hasImage" variant="alt"
                     :icon="icons.SearchSolid"
                     :label="$t('forms.shared.search')"
                     @click="onThumbnailSelection"/>

      <template v-if="hasImage">
        <template v-if="thumbnail">
          <figure class="figure-with-btn__image-container">
            <DashmixButton class="figure-with-btn__delete-btn" variant="icon" theme="danger" :icon="icons.TrashSolid"
                           @click="onThumbnailRemove"/>
            <DashmixFile class="figure-with-btn__image" :file="thumbnail"/>
            <figcaption>{{ imgTitle }}</figcaption>
          </figure>
        </template>

        <template v-else>
          <p class="my-3"><b>{{ $t('forms.image.not-found', { id: _content.thumbnail.value }) }}</b></p>
        </template>
      </template>
    </div>
    <div class="form-group col-6">
      <label for="description" class="mt-3">{{ $t('forms.embed.description') }}</label>
      <DashmixTextArea :model.sync="_content.description" name="description"/>
      <DashmixCheck class="mt-2" :model="_content.autoplay" @update:model="onAutoplayToggle" name="autoplay"
                    label="Auto-odtwarzanie po najechaniu"/>
    </div>
    </div>
  `
    })
], EmbedVideoSwitchPartialForm);
exports.EmbedVideoSwitchPartialForm = EmbedVideoSwitchPartialForm;
//# sourceMappingURL=EmbedVideoSwitch.form.js.map